import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#chevron-right_svg__a)">
      <path fill="#263E6A" d="M9.41 6 8 7.41 12.58 12 8 16.59 9.41 18l6-6z" />
    </g>
    <defs>
      <clipPath id="chevron-right_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgChevronRight;
